module.exports = __webpack_public_path__ + "media/dogs/dachshund-in-heart-3d51f1c3.svg";